<template>
  <v-layout column>
    <SearchAISubtitle
      :title="$t('ai.generatedHintBar.title')"
      :secondaryText="$t('ai.generatedHintBar.btnText')"
      secondaryIcon="refresh"
      :ish3="true"
      @onSecondaryActionClick="handleResetAi"
      class="mt-0"
    ></SearchAISubtitle>
    <v-layout class="ml-5" align-center>
      <CustomButton
        :text="$t('ai.generatedHintBar.showResultsBtn', {source: defaultSource})"
        icon="arrow_forward"
        @onClick="handleShowResults"
      ></CustomButton>
      <span v-html="$t('ai.generatedHintBar.selectOtherSource')"></span>
      <img class="info-bar-icon-source" src="../../../../static/source-logo/google-scholar-icon.svg" alt="Google Scholar Icon" />
    </v-layout>
  </v-layout>
</template>

<script>
import HintBar from './HintBar.vue'
import SearchAISubtitle from '../searchAi/SearchAISubtitle.vue'
import CustomButton from './buttons/CustomButton.vue'

export default {
  name: 'GeneratedContentInfoBar',
  components: { CustomButton, SearchAISubtitle, HintBar },
  computed: {
    defaultSource: { get () { return this.$store.getters.getQueryDefaultOperator || 'Bing' } }
  },
  methods: {
    handleResetAi () {
      this.$store.dispatch('resetAiState')
    },
    handleShowResults () {
      this.$store.dispatch('handleShowResultsFromAi')
    }
  }
}
</script>

<style scoped lang="scss">
.info-bar {
  &-icon-source {
    background-color: $bg-primary;
    border-radius: 50%;
    outline: 4px solid $light-blue-400;
    padding: 4px;
    margin: 0 10px;
    width: 34px;
  }
}
.generated-content-subtitle-container {
  margin-top: 0;
}
.slot-wrapper > div > span {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/GeneratedContentInfoBar.vue